import { gql } from 'graphql-tag'

import { BREAKOUT_SESSION_JOIN_BANNER_SESSION_REGISTRATION } from '@/components/Series/Banners/BreakoutSessionBanner/internal/BreakoutSessionJoinBanner.hasura'

export const JOIN_BREAKOUT_SESSION_SUBSCRIPTION = gql`
  subscription JoinBreakoutSession($currentUserId: Int!, $sessionId: Int!) {
    session_registration(
        where: {
            session_id: { _eq: $sessionId },
            user_id: { _eq: $currentUserId },
            session_breakout_id: { _is_null: false}
        },
        limit: 1
    ) {
      ...BreakoutSessionJoinBannerSessionRegistration
    }
  }

  ${BREAKOUT_SESSION_JOIN_BANNER_SESSION_REGISTRATION}
`
